import React, { useEffect, useState } from "react";
import ImgWithTitle from "../../component/workspaceContainer/ImgWithTitle";
import Text from "../../component/text/Text";
import { TextButton } from "../../component/buttonComponent/ButtonComponent";
import "./ForgotPassword.css";
import SnackBar from "../../component/Snackbar/Snackbar";
import FooterImage from "../../image/header.png";
import Cookies from "js-cookie";
import LoadingSpinner from "../../component/loading/LoadingSpinner";
import { APISendForgetPasswordEmail } from "../../config/utilities/APIs";

const COOLDOWN_DURATION = 60;

const CheckYourEmail = () => {
  const [loading, setLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarType, setSnackbarType] = useState("");
  const [snackbarTitle, setSnackbarTitle] = useState("");
  const [snackbarSubtitle, setSnackbarSubtitle] = useState("");
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    // Check if cooldown timestamp exists in localStorage
    const storedTimestamp = localStorage.getItem("resendCooldownTimestamp");
    if (storedTimestamp) {
      const timeElapsed = Math.floor(
        (Date.now() - parseInt(storedTimestamp)) / 1000
      );
      const remainingTime = COOLDOWN_DURATION - timeElapsed;
      if (remainingTime > 0) {
        setCooldown(remainingTime);
      } else {
        localStorage.removeItem("resendCooldownTimestamp"); // Clear expired cooldown
      }
    }
  }, []);

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const btnResend = async () => {
    if (cooldown > 0) return;
    const timestamp = Date.now();
    localStorage.setItem("resendCooldownTimestamp", timestamp);
    setCooldown(COOLDOWN_DURATION);

    setLoading(true);

    try {
      const email = Cookies.get("resetEmail");
      const response = await APISendForgetPasswordEmail(email, setLoading);

      if (response.status === 200) {
        setShowSnackbar(true);
        setSnackbarTitle("Resent Email");
        setSnackbarSubtitle("Your reset password email has been resent.");
        setSnackbarType("Email");
      } else {
        throw new Error(
          response.response?.data?.message || "Failed to send email"
        );
      }
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarTitle("Resend Reset Password Failed");
      setSnackbarSubtitle(error.message || "An error occurred");
      setSnackbarType("error");
      localStorage.removeItem("resendCooldownTimestamp");
      setCooldown(0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "#ffffff",
            zIndex: 9999,
          }}
        >
          <LoadingSpinner size="large" color="#ffb502" />
        </div>
      ) : (
        <>
          <div className="forgot-password-container-main">
            <div className="forgot-password-check-email-container">
              <ImgWithTitle
                titleText="Check your email"
                subText="If the email you've entered exists in our system, we've sent instructions for resetting your password. Be sure to check your spam folder!"
                icon="Insights"
              />
              <div className="text-button-row">
                <Text
                  className="login-row-text"
                  color="#475467"
                  size="0.875rem"
                  weight="400"
                  text="Didn't receive the email?"
                  align="left"
                />
                <TextButton
                  label={
                    cooldown > 0 ? `Resend in ${cooldown}s` : "Click to resend"
                  }
                  onClickFunction={btnResend}
                  className={
                    cooldown > 0 ? "text-button-disabled" : "text-button-active"
                  }
                  disabled={cooldown > 0}
                />
              </div>
            </div>
            <div className="login-logo-footer">
              <div className="login-logo">
                <img
                  loading="lazy"
                  src={FooterImage}
                  className="logo"
                  alt="header-logo"
                />
              </div>
            </div>
            {showSnackbar && (
              <div className="notification">
                <SnackBar
                  state={showSnackbar}
                  setState={setShowSnackbar}
                  title={snackbarTitle}
                  subtitle={snackbarSubtitle}
                  module={snackbarType}
                  action={snackbarType}
                />
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default CheckYourEmail;
